import { FeatureManagementType, ModelScopeSettingResponse, ModelScopeSettingStatusType, ModelScopeSettingType, UpdateModelScopeSettingsRequest } from "@api/apiClient";
import { useAppSettings } from "@api/appSettings";
import { useUpdateModelScopeSetting } from "@api/modelScopes";
import useAppStore from "@hooks/useAppStore";
import i18n from "@i18n/i18n";
import { Box, Card, CardContent, Container, Grid, Switch, Typography, useTheme } from "@mui/material";
import { observer } from "mobx-react";
import { ChangeEvent, useEffect, useState } from "react";
import ModelScopesGrid from "./ModelScopesGrid";

export interface ModelScopesPageProps {
  mode: ModelScopeSettingType;
  data?: ModelScopeSettingResponse[];
}

const ModelScopesPage = observer((props: ModelScopesPageProps) => {
  console.log("ModelScopes", props);
  const theme = useTheme();
  const [isChecked, setIsChecked] = useState(false);
  const appStore = useAppStore();
  const appSettings = useAppSettings();
  const updateModelScopeSetting = useUpdateModelScopeSetting(ModelScopeSettingType.Global, appStore.applicationSettings?.modelScopeSetting?.modelScopeSettingId);

  useEffect(() => {
    if (appStore.hasFeature(FeatureManagementType.ModelScopes)) {
      setIsChecked(appStore.applicationSettings?.modelScopeSetting?.status === ModelScopeSettingStatusType.Active);
    }
  }, [appStore.features, appStore.applicationSettings?.modelScopeSetting?.status]);

  const handleGlobalModelScopeChange = async (changeValue: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(changeValue.target.checked);

    const enableModelScopes = changeValue.target.checked;
    const modelScopeSettingsId = appStore.applicationSettings?.modelScopeSetting?.modelScopeSettingId ?? null;
    const updateModelScopeSettingsRequest: UpdateModelScopeSettingsRequest = createPayload(modelScopeSettingsId, enableModelScopes);
    await updateModelScopeSetting.mutateAsync(updateModelScopeSettingsRequest as any);
    await appSettings.refetch();
  };

  const createPayload = (modelScopeSettingsId: string | null, enableModelScopes: boolean): UpdateModelScopeSettingsRequest => {
    return new UpdateModelScopeSettingsRequest({
      modelScopeSettingsId,
      //modelScopeSettingsType: ModelScopeSettingType.Global, // Future use
      status: enableModelScopes ? ModelScopeSettingStatusType.Active : ModelScopeSettingStatusType.InActive,
    } as UpdateModelScopeSettingsRequest);
  };

  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Typography variant="h6" fontWeight="bold">
            {i18n.t("model-scopes-tab.model-scopes")}
          </Typography>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Card elevation={3} sx={{ width: "100%" }}>
            <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">{i18n.t("model-scopes-tab.enable-model-scopes-toggle")}</Typography>
                <Typography variant="subtitle1" color={theme.palette.grey[500]} fontSize="0.75rem">
                  {i18n.t("model-scopes-tab.enable-model-scopes-message")}
                </Typography>
              </Box>
              <Switch checked={isChecked} onChange={handleGlobalModelScopeChange} />
            </CardContent>
          </Card>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 1, width: "100%", position: "relative" }}>
          <ModelScopesGrid mode={ModelScopeSettingType.Global} modelScopeSettingId={appSettings.data?.modelScopeSetting?.modelScopeSettingId} />
        </Grid>
      </Grid>
    </Container>
  );
});

export default ModelScopesPage;
